import { render, staticRenderFns } from "./PaginationAlignment.vue?vue&type=template&id=a65bd1b0&"
import script from "./PaginationAlignment.vue?vue&type=script&lang=js&"
export * from "./PaginationAlignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports